module.exports = __webpack_public_path__ + "img/ufa-bet-support.4bbed820.webp";